import { Button, Col, Form, Row } from 'react-bootstrap'
import * as Yup from 'yup'

type Values = {
  orientation: string
  typeOf: string
  numberOfCharactersPerRow: number
  numberOfRows: number
  numberOfColumns: number
}

type EnumValues = {
  columnSettingOrientations: Record<string, string>
  columnSettings: Record<string, string>
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  isValid: boolean
  enumValues: EnumValues
  isSettingWritable: boolean
}

const _ColumnSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isValid,
  enumValues,
  isSettingWritable
}: Props) => {
  return (
    <Form noValidate onSubmit={handleSubmit}>
      <Row className='mb-3'>
        <Form.Group as={Col}>
          <Form.Label column>組方向</Form.Label>
          <Col>
            <Form.Control
              as='select'
              type='text'
              name='orientation'
              value={values?.orientation || ''}
              onBlur={handleBlur}
              onChange={handleChange}
              isInvalid={!!(touched.orientation && errors.orientation)}
              disabled
            >
              {Object.keys(enumValues.columnSettingOrientations).map((k) => (
                <option key={k} value={k}>
                  {enumValues.columnSettingOrientations[k]}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type='invalid'>{errors.orientation}</Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label column>段組体裁</Form.Label>
          <Col>
            <Form.Control
              as='select'
              type='text'
              name='typeOf'
              value={values.typeOf || ''}
              onBlur={handleBlur}
              onChange={handleChange}
              isInvalid={!!(touched.typeOf && errors.typeOf)}
              disabled={!isSettingWritable}
            >
              {Object.keys(enumValues.columnSettings).map((k) => (
                <option key={k} value={k}>
                  {enumValues.columnSettings[k]}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type='invalid'>{errors.typeOf}</Form.Control.Feedback>
          </Col>
        </Form.Group>
      </Row>
      <Row className='mb-3'>
        <Form.Group as={Col}>
          <Form.Label column>字数</Form.Label>
          <Col>
            <Form.Control
              type='number'
              name='numberOfCharactersPerRow'
              value={values?.numberOfCharactersPerRow || ''}
              onBlur={handleBlur}
              onChange={handleChange}
              isInvalid={!!(touched?.numberOfCharactersPerRow && errors?.numberOfCharactersPerRow)}
              disabled={!isSettingWritable || values?.typeOf === 'regular'}
            />
            <Form.Control.Feedback type='invalid'>{errors?.numberOfCharactersPerRow}</Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label column>行数</Form.Label>
          <Col>
            <Form.Control
              type='number'
              name='numberOfRows'
              value={values?.numberOfRows || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={!!(touched?.numberOfRows && errors?.numberOfRows)}
              disabled={!isSettingWritable || values?.typeOf === 'regular'}
            />
            <Form.Control.Feedback type='invalid'>{errors?.numberOfRows}</Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label column>段数</Form.Label>
          <Col>
            <Form.Control
              type='number'
              name='numberOfColumns'
              value={values?.numberOfColumns || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={!!(touched?.numberOfColumns && errors?.numberOfColumns)}
              disabled={!isSettingWritable || values?.typeOf === 'regular'}
            />
            <Form.Control.Feedback type='invalid'>{errors?.numberOfColumns}</Form.Control.Feedback>
          </Col>
        </Form.Group>
      </Row>
      <br />
      <Row>
        <Col>
          <Button
            type='submit'
            disabled={!isSettingWritable || !isValid || Object.keys(touched).length === 0}
            size='sm'
          >
            更新
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export const ColumnSettingForm = Object.assign(_ColumnSettingForm, {
  schema: Yup.object().shape({
    orientation: Yup.string().required(),
    typeOf: Yup.string().required(),
    numberOfCharactersPerRow: Yup.number().required().min(10).max(30),
    numberOfRows: Yup.number().required().min(30).max(100),
    numberOfColumns: Yup.number().required().min(1).max(15)
  })
})
